export const endpoint = {
	userInfo: "loginAdmin",
	adminUser: "admin-user",
	quotation: "quotation",
	updateQuotationStatus: "updateQuotationStatus",
	deleteQuotation: "deleteQuotation",
	sendMail: "sendMail",
};
